import { GridApiRef } from '@material-ui/x-grid';
import { appActions } from 'redux/slice/app/app';
import { CustomSocketDispatch } from 'redux/store';

// action wrapper to check selection. uses action for rows, or alerts if none are selected
export const actionWithSelectionHOC = (apiRef: GridApiRef, dispatch: CustomSocketDispatch) => (action: () => void) => (): void => {
  const selected = apiRef.current.getSelectedRows();
  selected.size === 0 ? dispatch(appActions.WARNING('You must have selected some rows for this action')) : action();
};
